import React, { useEffect } from 'react'

import api, { ICalendar } from '@api'
import EvoSelect from './EvoSelect'

interface SpaceTypeSelectProps {
  value: ICalendar | null
  onChange: (calendar: { id: string; calendarName: string } | null) => void
  itemDisabled?: (calendar: ICalendar) => boolean
  disabled: boolean
}

function CalendarSelect({ value, onChange, disabled }: SpaceTypeSelectProps) {
  const calendars: ICalendar[] = useCalendars()

  const formatItems = (list: any[] | undefined) => {
    const formattedItems: any = list?.map((item: any) => {
      return {
        label: item?.calendarName,
        value: item?.id,
      }
    })
    return formattedItems
  }
  return (
    <EvoSelect
      disabled={disabled}
      isSearchable
      value={{ label: value?.calendarName, value: value?.id }}
      options={formatItems(calendars)}
      onChange={(calendar: any) =>
        onChange(
          calendar
            ? {
                id: calendar.value,
                calendarName: calendar.label,
              }
            : null
        )
      }
      isClearable={true}
      size="small"
    />
  )
}

export default CalendarSelect

let persistedState: ICalendar[] = []

export function useCalendars(): ICalendar[] {
  const [calendars, setCalendars] = React.useState<ICalendar[]>(persistedState)

  useEffect(() => {
    api.company.fetchCalendars().then((calendars: ICalendar[]) => {
      setCalendars(calendars)
    })
  }, [])

  useEffect(() => {
    // Cache initial list
    if (!persistedState?.length && calendars?.length) {
      persistedState = calendars
    }
  })

  return calendars
}
